import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetAllOptins',
            headers: {},
            args: {
                ...payload,
            },
        });

        return result;
    };
};
